import styled, { createGlobalStyle, css } from "styled-components";
import style from "../../theme";

export const ToastGlobalStyle = createGlobalStyle`
  :root {
    --toastify-color-dark: ${style.colors.primary};
    --toastify-text-color-light: ${style.colors.primary};
  }
  .Toastify__toast {
    padding: 16px 24px 16px 27px;
    border: 1px solid ${style.colors.graySolid3};
    box-shadow: 0px 1px 3px 1px rgba(53, 64, 88, 0.16);
    border-radius: 4px;
    position: relative;
    cursor: auto;
  }
  .Toastify__toast::before {
    content: " ";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 7px;
    background: ${style.colors.purpleBlue};
  }
  .Toastify__toast-body {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 18px;
  }
`;

export const StyledIconWrapper = styled.div`
  position: absolute;
  top: 7px;
  right: 7px;
  opacity: 0.75;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

export const StyledToastMessageTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledToastMessageProgress = styled.div<{ $prct: number }>`
  margin: 0 8px 0 -8px;
  height: 32px;
  width: 32px;
  flex: 0 0 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s;
  ${({ theme, $prct }) => {
    const deg = ($prct / 100) * 360;
    return css`
      background: conic-gradient(
        rgba(188, 189, 190, 0.2) 0deg ${deg}deg,
        ${theme.colors.graySolid4} ${deg}deg 360deg
      );
    `;
  }}
  & > span {
    border-radius: 50%;
    display: block;
    width: 21px;
    height: 21px;
    background: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledToastMessageCtasWrapper = styled.div`
  margin-top: 8px;
  & > button + button {
    margin-left: 6px;
  }
`;
